export { Automatic as AutomaticLayout } from './Automatic';
